import GalleryItem from './GalleryItem'
import type { UnifiedGalleryItem } from '../Gallery'

interface GalleryGridProps {
  items: UnifiedGalleryItem[]
  onItemClick: (item: UnifiedGalleryItem) => void
}

function GalleryGrid({ items, onItemClick }: GalleryGridProps) {
  return (
    <div className="gallery-grid">
      {items.map((item) => (
        <GalleryItem key={item.id} item={item} onClick={() => onItemClick(item)} />
      ))}
    </div>
  )
}

export default GalleryGrid
